import React, { useContext, useEffect, useState } from 'react'
import SideBar from './SideBar'
import Header from './Header'
import Footer from './Footer'
import { AuthContext } from './../../Auth/AuthContext'
import { useQuery } from '@apollo/client'
import { APP_CONFIG } from '../../graphql/Auth/auth'
import { GET_USER_BY_ID } from '../../graphql/Catalog/Users/user'
import SideBarRight from './SideBarRight'
import { objNameRoles as roles } from '../../const/constRoles'
import { useLocation } from 'react-router-dom'

const pathsWithoutSidebar = [
  '/dashboardMigrants/logged',
  '/dashboardMigrants/logged/user/profile',
  '/dashboardMigrants/logged/user/history',
  '/dashboardMigrants/contact',
]

// Agrega coincidencia para /dashboardMigrants/logged/user/history/(algún número)
const isPathWithoutSidebar = (path) => {
  if (pathsWithoutSidebar.includes(path)) return true
  // Coincide con /dashboardMigrants/logged/user/history/ seguido de un número
  if (/^\/dashboardMigrants\/logged\/user\/history\/\d+$/.test(path)) return true
  return false
}

export const LayoutLogged = ({ children }) => {
  const { user } = useContext(AuthContext)
  const [showSidebarRight, setShowSidebarRight] = useState(false)
  const [typeSidebarRight, setTypeSidebarRight] = useState(null)
  const location = useLocation()
  const currentPath = location.pathname
  
  const { data: dataAvatar } = useQuery(GET_USER_BY_ID, {
    variables: {
      getUserByIdId: parseInt(user.idUser),
    },
  })
  const [dataSys, setDataSys] = useState({
    appLogo: '',
    appName: '',
    appMiniLogo: '',
    appFavicon: '',
  })

  const { loading, error, data } = useQuery(APP_CONFIG)

  //LOAD SYSCONFIG
  useEffect(() => {
    if (!loading) {
      if (data !== undefined || data == null) {
        if (error) return
        setDataSys({
          appLogo: data.getConfigSys.project_logo,
          appName: data.getConfigSys.project_name,
          appMiniLogo: data.getConfigSys.project_mini_logo,
          appFavicon: data.getConfigSys.project_favicon,
        })
        localStorage.setItem('configSys', JSON.stringify(data.getConfigSys))

        let headTitle = document.querySelector('head')
        let setFavicon = document.createElement('link')
        setFavicon.setAttribute('rel', 'icon')
        setFavicon.setAttribute(
          'href',
          `${data.getConfigSys.project_mini_logo}`
        )
        headTitle.appendChild(setFavicon)
      }
    }
  }, [loading, error, data])

  const toggleSidebarRight = () => {
    setShowSidebarRight(!showSidebarRight)
  }

  return (
    <>
      {pathsWithoutSidebar.includes(currentPath) || 
      isPathWithoutSidebar(currentPath)? (
        <>
          {children}
        </>
      ) : (
        <div
          className={`wrapper ${
            user.role === roles.chofer_pipas ? 'wrapperWithoutMargins' : ''
          }`}
        >
          <Header
            avatar={
              dataAvatar?.GetUserById?.avatarUrl !== null
                ? dataAvatar?.GetUserById?.avatarUrl
                : null
            }
            toggleSidebar={toggleSidebarRight}
            setTypeSidebar={setTypeSidebarRight}
          />

          {user.role !== roles.chofer_pipas && (
            <>
              <SideBar
                titleApp={dataSys.appName}
                prefixIcon="fas fa-"
                iconApp={dataSys.appLogo}
                logoIcon={dataSys.appMiniLogo}
                user={user}
                avatar={
                  dataAvatar?.GetUserById?.avatarUrl !== null
                    ? dataAvatar?.GetUserById?.avatarUrl
                    : null
                }
                modules={user.userPermissions}
              />

              {showSidebarRight && (
                <SideBarRight
                  setType={setTypeSidebarRight}
                  type={typeSidebarRight}
                  toggleSidebar={toggleSidebarRight}
                />
              )}
            </>
          )}

          <div className="content-wrapper">
            <section className="content">
              <div className="container-fluid">
                <div className="content-fade">{children}</div>
              </div>
            </section>
          </div>
          <Footer />
        </div>
      )}
    </>
  )
}

export default LayoutLogged
